import { __extends } from "tslib";
import React from "react";
import { Text, View } from "react-native";
import moment from "moment";
import { isSameDay } from "../utils";
import PropTypes from "prop-types";
import styles from "./PnmacDay.styles.js";
var PnmacDay = /** @class */function (_super) {
  __extends(PnmacDay, _super);
  function PnmacDay() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacDay.prototype.render = function () {
    if (!isSameDay(this.props.currentMessage, this.props.previousMessage)) {
      return /*#__PURE__*/React.createElement(View, {
        style: [styles.container, this.props.containerStyle],
        testID: "day"
      }, /*#__PURE__*/React.createElement(View, {
        style: [styles.wrapper, this.props.wrapperStyle]
      }, /*#__PURE__*/React.createElement(Text, {
        style: [styles.text, this.props.textStyle]
      }, moment(this.props.currentMessage.createdAt).locale(this.context.getLocale ? this.context.getLocale() : "en").format("ll").toUpperCase())));
    }
    return null;
  };
  return PnmacDay;
}(React.Component);
PnmacDay.contextTypes = {
  getLocale: PropTypes.func
};
PnmacDay.defaultProps = {
  currentMessage: {
    // TODO test if crash when createdAt === null
    createdAt: null
  },
  previousMessage: {},
  containerStyle: {},
  wrapperStyle: {},
  textStyle: {}
};
PnmacDay.propTypes = {
  currentMessage: PropTypes.object,
  previousMessage: PropTypes.object,
  containerStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  wrapperStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  textStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};
export default PnmacDay;